import React from 'react';

export default function Pentagon() {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-pentagon-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 0l8 6.5-3 9.5H3L0 6.5 8 0z" />
    </svg>
  );
}
